<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot-scope="{ row }" slot="status">
        <el-tag
          style="
            font-size: 14px;
            width: 76px;
            height: 32px;
            line-height: 32px;
            text-align: center;
          "
          :type="row.status === 0 ? 'danger' : 'success'"
        >
          {{ row.status === 0 ? "未启用" : "已启用" }}</el-tag
        >
      </template>
      <template slot="projectId2Search">
        <el-select v-model="queryProjectId" placeholder="请选择 项目名称">
          <el-option
            v-for="(item, index) in projectIdList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>

      <!-- <template slot="projectIdForm">
        <el-select v-model="form.projectId" @change="projectIdChange" placeholder="请选择项目">
          <el-option
            v-for="(item,index) in projectIdList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template> -->

      <template slot="groupIdForm">
        <el-select v-model="form.groupId" placeholder="请选择 服务班组">
          <el-option
            v-for="(item, index) in projectGroupList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="moduleTypeForm">
        <el-select
          v-model="form.moduleType"
          @change="moduleTypeChange"
          placeholder="请选择 工单类型"
        >
          <el-option
            v-for="(item, index) in moduleTypeList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          ></el-option>
        </el-select>
      </template>
      <template slot="projectIdForm">
        <el-select
          v-model="form.projectId"
          placeholder="请选择 项目名称"
          @change="projectIdChange"
        >
          <el-option
            v-for="(item, index) in projectIdList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          v-if="permissionList.flowBtn"
          icon="el-icon-s-operation"
          @click.native="openOrderSettingFlow(scope.row)"
          >流程
        </el-button>
        <el-button
          v-if="permissionList.componentsBtn"
          type="text"
          icon="el-icon-s-tools"
          size="small"
          @click.native="openExtraComponents(scope.row)"
          >附加组件
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permissionList.useBtn"
          icon="el-icon-edit-outline"
          @click.native="changeStatus(scope.row)"
          >{{ getLabelName(scope.row.status) }}
        </el-button>
        <!-- v-if="permissionList.componentsBtn" -->
        <el-button
          type="text"
          icon="el-icon-s-tools"
          size="small"
          @click.native="openSubModuleList(scope.row)"
          >子类型
        </el-button>
        <el-button
        v-if="scope.row.moduleType=='7'"
          type="text"
          icon="el-icon-s-tools"
          size="small"
          @click.native="openSelfForm(scope.row)"
          >自定义表单
        </el-button>
        <el-button
          type="text"
          icon="el-icon-s-tools"
          size="small"
          @click.native="openApproveRule(scope.row)"
          >派单规则
        </el-button>
      </template>
    </avue-crud>

    <hr-dialog width="50%" :visible.sync="selfFormDialogVisible" operatorModel='view' title="字段设置" >
      <template slot="body">
        <selfForm v-if="selfFormDialogVisible" :option='selfFormoption'></selfForm>
      </template>
    </hr-dialog>
    <el-dialog
      title="工单流程编辑"
      :visible.sync="dialogOrderSettingFlowVisible"
      append-to-body
      fullscreen
    >
      <!--  -->
      <order-setting-flow
        v-if="dialogOrderSettingFlowVisible"
        :flowid="flowid"
        :projectId="projectId"
        @closeDialog="handleCloseDialog"
      />
    </el-dialog>
    <el-dialog
      title="工单附加组件编辑"
      :visible.sync="dialogExtraComponentsVisible"
      append-to-body
      fullscreen
    >
      <!--  -->
      <extra-components
        v-if="dialogExtraComponentsVisible"
        :flowid="flowid"
        :projectId="projectId"
      />
    </el-dialog>
    <el-dialog
      title="附加组件"
      :visible.sync="dialogOrderSettingActionVisible"
      fullscreen
      append-to-body
    >
      <order-setting-action
        v-if="dialogOrderSettingActionVisible"
        :flowid="flowid"
        :projectId="projectId"
        :componentRow="componentRow"
      />
    </el-dialog>
    <el-dialog
      title="子类型"
      :visible.sync="dialogSubModuleListVisible"
      fullscreen
      append-to-body
    >
      <order-setting-sub-module
        v-if="dialogSubModuleListVisible"
        :projectId="queryProjectId"
        :settingId="settingId"
        :moduleType="moduleTypeToSubModule"
      />
    </el-dialog>
    <el-dialog
      title="派单规则"
      :visible.sync="dialogApproveRuleVisible"
      fullscreen
      append-to-body
    >
      <approve-rule
        v-if="dialogApproveRuleVisible"
        :row="approveRuleRow"
      ></approve-rule>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getGroupList,
  getProjectList,
  changeOrderSettingStatus,
  getDictionary,
} from "@/api/v4ward/ordersetting/setting/ordersetting";
import { mapGetters } from "vuex";
import ExtraComponents from "./extra-components";
import OrderSettingFlow from "./order-setting-flow";
import OrderSettingSubModule from "./order-setting-sub-module";
import OrderSettingAction from "@/views/v4ward/ordersetting/action/ordersettingaction";
import ApproveRule from "./approve-rule";
//
import ProjectUserSelector from "@/views/components/user-edit-box";
//
import selfForm from './selfForm'
export default {
  components: {
    ExtraComponents,
    OrderSettingFlow,
    OrderSettingAction,
    OrderSettingSubModule,
    ProjectUserSelector,
    ApproveRule,
    selfForm
  },
  data() {
    return {

      selfFormDialogVisible:false,
      selfFormoption:{
        projectId:'',
        moduleType:'',
      },
      isClickSearch:true,
      moduleTypeToSubModule: "",
      componentRow: "",
      flowid: "",
      projectId: "",
      queryProjectId: "",
      projectIdList: [],
      dialogOrderSettingFlowVisible: false,
      dialogExtraComponentsVisible: false,
      dialogOrderSettingActionVisible: false,
      dialogSubModuleListVisible: false,
      dialogApproveRuleVisible: false,
      approveRuleRow: null,
      form: {},
      query: {
        projectId: "",
      },
      // loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      projectGroupList: [],
      option: {
        height: "auto",
        calcHeight: 100,
        tip: false,
        searchShow: true,
        searchMenuSpan: 12,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        indexLabel: "序号",
        align: "left",
        dialogClickModal: false,
        dialogWidth: '50%',
        columnBtn: false,
        menuWidth: 280,
        column: [
          {
            label: "项目名称",
            prop: "projectId2",
            type: "select",
            hide: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            search: true,
            searchslot: true,
          },
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            dicUrl: "api/v4ward/project/getProjectList",
            editDisabled: true,
            formslot: true,
            props: {
              label: "name",
              value: "id",
            },
            rules: [
              {
                required: true,
                message: "请选择项目名称",
                trigger: "change",
              },
            ],
          },
          {
            label: "工单类型",
            prop: "moduleType",
            type: "select",
            editDisabled: true,
            formslot: true,
            width: 120,
            search: true,
            dicUrl: "/api/blade-system/dict/dictionary?code=module_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            rules: [
              {
                required: true,
                message: "请选择工单类型",
                trigger: "change",
              },
            ],
          },
          {
            label: "工单名称",
            prop: "orderName",
            placeholder: "请输入 工单名称",
            maxlength: 15,
            rules: [
              {
                required: true,
                message: "请输入工单名称",
                trigger: "change",
              },
            ],
          },
          // {
          //   label: "服务班组",
          //   prop: "groupName",
          //   editDisabled: true,
          //   addDisplay: false,
          // },

          {
            label: "服务班组",
            prop: "groupName",
            type: "select",
            // dicUrl: '/api/v4ward/group/getGroupList?projectId={{key}}',
            // editDisplay: false,
            dicData: [],
            // hide: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            props: {
              label: "name",
              value: "id",
            },
            rules: [
              {
                required: true,
                message: "请选择服务班组",
                trigger: "change",
              },
            ],
          },
          {
            label: "服务班组",
            prop: "groupId",
            type: "select",
            // dicUrl: '/api/v4ward/group/getGroupList?projectId={{key}}',
            // editDisplay: false,
            dicData: [],
            hide: true,
            props: {
              label: "name",
              value: "id",
            },
            formslot: true,
            rules: [
              {
                required: true,
                message: "请选择服务班组",
                trigger: "change",
              },
            ],
          },
          {
            label: "状态",
            prop: "status",
            addDisplay: false,
            editDisabled: true,
            width: 100,
            value: 0,
            type: "select",
            slot: true,
            dicData: [
              { label: "未启用", value: 0 },
              { label: "已启用", value: 1 },
            ],
            rules: [
              {
                required: true,
                message: "请选择状态",
                trigger: "change",
              },
            ],
          },
          {
            label: "备注说明",
            prop: "description",
            type: "textarea",
            overHidden: true,
            placeholder: "请输入 备注说明",
            span: 24,
            minRows: 2,
            maxlength: 200,
          },
        ],
      },
      data: [],
      moduleTypeList: [],
    };
  },
  watch: {
    "form.projectId"() {
      this.initGroupList();
    },
    "form.moduleType"() {
      this.refreshGroupList();
    },
  },
  created() {
    this.initProjectIdList();
    getDictionary({ code: "module_type" }).then((res) => {
      this.moduleTypeList = res.data;
    });
  },
  mounted(){
    this.$nextTick(() => {

              setTimeout(()=>{
              console.log(this.$refs.crud)
              this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{
                this.isClickSearch = !this.isClickSearch
                console.log(1212121)
                    if(this.isClickSearch){
                      this.option.height = this.bodyHeight - 340
                    }else{
                      this.option.height = this.bodyHeight - 280;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
            });
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.ordersetting_add, true),
        viewBtn: this.vaildData(this.permission.ordersetting_view, false),
        delBtn: this.vaildData(this.permission.ordersetting_delete, false),
        editBtn: this.vaildData(this.permission.ordersetting_edit, true),
        flowBtn: this.vaildData(this.permission.ordersetting_flow, true),
        componentsBtn: this.vaildData(
          this.permission.ordersetting_components,
          true
        ),
        useBtn: this.vaildData(this.permission.ordersetting_use, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    openSelfForm(row){
      console.log(row)
      this.selfFormoption.projectId = row.projectId
      this.selfFormoption.moduleType = row.moduleType
      this.selfFormDialogVisible = true
    },
    moduleTypeChange(val) {
      let projectId = this.form.projectId;
      console.log("this.form======>", this.form);
      this.form = Object.assign({}, this.form, { groupId: "", $groupId: "" });
      console.log("this.form======>", this.form);
      console.log(this.$refs.crud);
      if (this.vdui.isNotEmpty(projectId)) {
        getGroupList({ projectId: projectId, moduleType: val }).then((res) => {
          this.projectGroupList = res.data;
          console.log(this.form.groupId);

          setTimeout(() => {
            this.form = Object.assign({}, this.form, {
              groupId: "",
              $groupId: "",
            });
          });
        });
      }
    },
    projectIdChange() {
      let projectId = this.form.projectId;
      if (this.vdui.isNotEmpty(projectId)) {
        this.form.moduleType = "";
        this.form.groupId = "";
        getGroupList({ projectId: projectId }).then((res) => {
          this.projectGroupList = res.data;
          console.log(this.form.groupId);
        });
      }
    },
    openSubModuleList(row) {
      console.log(row);
      this.settingId = row.id;
      this.moduleTypeToSubModule = row.moduleType;
      this.dialogSubModuleListVisible = true;
    },
    initProjectIdList() {
      getProjectList().then((res) => {
        this.projectIdList = res.data;
        if (this.projectIdList.length > 0) {
          this.queryProjectId = this.projectIdList[0].id;
          this.onLoad();
        }
      });
    },
    initGroupList() {
      let projectId = this.form.projectId;
      if (this.vdui.isNotEmpty(projectId)) {
        getGroupList({ projectId: projectId }).then((res) => {
          this.projectGroupList = res.data;
          this.refreshGroupList();
        });
      }
    },
    refreshGroupList() {
      let moduleType = this.form.moduleType;
      let filterList;
      var groupIdColumn = this.findObject(this.option.column, "groupId");
      if (this.vdui.isEmpty(moduleType)) {
        filterList = this.projectGroupList;
      } else {
        filterList = this.projectGroupList.filter((proup) => {
          return proup.moduleType+'' === moduleType+'';
        });
      }
      if (filterList.length > 0) {
        groupIdColumn.dicData = filterList;
      } else {
        groupIdColumn.dicData = [{}];
      }
      // this.form.groupId = '';
      this.projectGroupList = groupIdColumn.dicData;
    },
    handleCloseDialog() {
      this.dialogOrderSettingFlowVisible = false;
    },
    changeStatus(row) {
      let status = row.status === 1 ? 0 : 1;
      let label = "确认停用此工单?";
      if (status === 1) {
        label = "附件组件是否已经配置?";
      }
      this.$confirm(label, {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      }).then(() => {
        let param = {
          id: row.id,
          status: status,
          projectId: row.projectId,
          moduleType: row.moduleType,
        };
        // eslint-disable-next-line no-unused-vars
        changeOrderSettingStatus(param).then((res) => {
          row.status = param.status;
          this.$message.success("操作成功!");
        });
      });
    },
    getLabelName(status) {
      if (status === 1) {
        return "停用";
      } else {
        return "启用";
      }
    },
    openOrderSettingFlow(row) {
      console.log("行数据:" + JSON.stringify(row));
      console.log("打开流程设置页面");
      this.flowid = row.id;
      this.projectId = row.projectId;
      this.dialogOrderSettingFlowVisible = true;
    },
    openExtraComponents(row) {
      console.log("行数据:" + JSON.stringify(row));
      console.log("打开附加组件设置页面");
      this.flowid = row.id;
      this.projectId = row.projectId;
      //this.dialogExtraComponentsVisible = true;
      this.componentRow = row;
      this.dialogOrderSettingActionVisible = true;
    },
    openApproveRule(row) {
      this.approveRuleRow = row;
      this.dialogApproveRuleVisible = true;
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
     setUiStandard(){
        let dom = this.$refs.crud.$children[4].$children[0].$refs.dialog
      dom.className+=" lhrodersetting01"
      dom.id = 'lhrodersetting01'
      console.log("***ee",this.$refs.crud.$children[4].$children[0].customClass)
        console.log("***dd",this.$refs.crud.$children[4].$children[0])
    },
    beforeOpen(done, type) {
      this.setUiStandard()
      console.log(type);
      if (["edit", "view"].includes(type)) {
        console.log(JSON.stringify(this.form));
        let groupName = this.form.groupName;
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          this.form.groupName = groupName;
          if (["edit"].includes(type)) {
            // this.initGroupList();
            this.form.moduleType = this.form.moduleType + "";
            let projectId = this.form.projectId;
            if (this.vdui.isNotEmpty(projectId)) {
              getGroupList({ projectId: projectId }).then((res) => {
                setTimeout(() => {
                  this.projectGroupList = res.data;
                  this.form = this.deepClone(this.form);
                  // this.refreshGroupList();
                });
                // this.refreshGroupList();
              });
            }
          }
        });
      } else if (["add"].includes(type)) {
        this.projectGroupList = [];
        this.refreshGroupList();
        this.cleanForm();
        // let projectId = this.form.projectId;
        //     if (this.vdui.isNotEmpty(projectId)) {
        //       getGroupList({projectId: projectId}).then(res => {
        //         this.projectGroupList = res.data;
        //         // this.refreshGroupList();
        //         console.log(this.form.groupId);
        //       })
        //     }
      }
      done();
    },

    cleanForm() {
      for (let key in this.form) {
        this.form[key] = null;
      }
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.vdui.isNotEmpty(this.queryProjectId)) {
        this.query.projectId = this.queryProjectId;
        this.form.projectId = this.queryProjectId;
        page = page || this.page;
        getList(
          Object.assign(
            { current: page.currentPage, size: page.pageSize },
            this.query
          )
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.selectionClear();
        });
      }
    },
  },
};
</script>

<style scoped>
  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
 ::v-deep .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
::v-deep .el-dialog__header{
  padding-bottom:0!important;
}
</style>
